module.exports = __webpack_public_path__ + "static/media/管理者.f165b593.png";